wbApp.factory('rentItemSvc', ['$resource', '$q','repositorySvc',
    function ($resource, $q, repositorySvc) {

        var RentItem = $resource('/restapi/rent-items/:id', {}, {
            'getById': { method: 'GET', url: '/restapi/rent-items/:id' },
            'getAll': { method: 'GET', isArray: true, url: '/restapi/rent-items' },
            'getAllByPlaceAndRentCategory': { method: 'GET', isArray: true, url: '/restapi/rent-items/find-by-place-and-rent-category' },
            'insert': { method: 'POST', url: '/restapi/rent-items' },
            'update': { method: 'PUT', url: '/restapi/rent-items/:id' },
            'delete': { method: 'DELETE', url: '/restapi/rent-items/:id' },
        });

        var rentItems;

        function createNew()
        {
            var rentItem = {
                isNew: true,
                itemCondition: 0
            };

            return rentItem;
        }

        function insert(model) {
            return repositorySvc.customPost(
                'insert',
                RentItem,
                model);
        }

        function remove(rentItemId) {
            rentItems = null;
            return repositorySvc.customDelete(
                'delete',
                RentItem,
                { id: rentItemId });
        }

        function update(model) {
            rentItems = null;
            return repositorySvc.customPutWithParams(
                'update',
                RentItem,
                { id: model.id },
                convertDatesToDateString(model));
        }

        function getById(rentItemId) {
            return repositorySvc.customGet('getById', RentItem, { id: rentItemId });
        }

        function getAll(refresh) {
            if (!rentItems || refresh) {
                rentItems = repositorySvc.customGet('getAll', RentItem, {});
            }
            return rentItems;
        }

        function resolvedEmptyArrayPromise() {
            var deferred = $q.defer();
            deferred.resolve([]);
            var result = [];
            result.$promise = deferred.promise;
            return result;
        }

        function getAllByPlaceAndRentCategory(placeId, rentCategoryId) {

            if (!placeId || !rentCategoryId) {
                return resolvedEmptyArrayPromise();
            }

            return repositorySvc.customGet('getAllByPlaceAndRentCategory', RentItem, {
                placeId: placeId,
                rentCategoryId: rentCategoryId
            });
        }

        function getUsedItemTypes(placeId, rentCategoryId) {

            if (!placeId || !rentCategoryId) {
                return resolvedEmptyArrayPromise();
            }

            var deferred = $q.defer();
            var result = [];
            

            repositorySvc.customGet('getAllByPlaceAndRentCategory', RentItem, {
                placeId: placeId,
                rentCategoryId: rentCategoryId
            }).$promise.then(function (data) {
                result.push.apply(result, _.keys(_.groupBy(data, function (item) { return item.itemTypeId; })));
                deferred.resolve(result);
            });

            result.$promise = deferred.promise;
            return result;
        }

        return {
            createNew: createNew,
            getById: getById,
            getAll: getAll,
            getAllByPlaceAndRentCategory: getAllByPlaceAndRentCategory,
            getUsedItemTypes: getUsedItemTypes,
            insert: insert,
            remove: remove,
            update: update,
        }
    }
]);